(function () {
  const LOG_PREFIX = '[cruise-live-preview]';

  function log() {
    if (!window.CRUISE_DEBUG) return;
    const args = Array.prototype.slice.call(arguments);
    console.log.apply(console, [LOG_PREFIX].concat(args));
  }

  function warn() {
    const args = Array.prototype.slice.call(arguments);
    console.warn.apply(console, [LOG_PREFIX].concat(args));
  }

  function error() {
    const args = Array.prototype.slice.call(arguments);
    console.error.apply(console, [LOG_PREFIX].concat(args));
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window.CruiseLivePreviewEnabled) {
      log('disabled (CruiseLivePreviewEnabled is falsy), skipping mount');
      return;
    }

    if (!window.PreviewEmbed || typeof window.PreviewEmbed.createVoyagePreview !== 'function') {
      error('widget script not loaded, skipping mount');
      return;
    }

    const containers = Array.prototype.slice.call(document.querySelectorAll('[data-cruise-live-preview]'));
    log('found containers:', containers.length, containers);
    if (!containers.length) return;

    const MAP_POSITION_VARS = ['--clp-top', '--clp-left', '--clp-width', '--clp-ratio', '--clp-left-n', '--clp-width-n'];
    const MAP_POSITION_NUMBER = /^\d+(\.\d+)?$/;
    const MAP_POSITION_RATIO = /^\d+(\.\d+)?(\s*\/\s*\d+(\.\d+)?)?$/;

    // "top; left; width; aspect-ratio" from the base image variant's own metafield; blank/malformed falls back
    // to the CSS defaults. Set on the overlay itself, so the values follow it into the zoom modal.
    function applyMapPosition(raw) {
      const parts = String(raw || '').split(';').map(function (part) { return part.trim(); });
      const valid = parts.length === 4
        && MAP_POSITION_NUMBER.test(parts[0])
        && MAP_POSITION_NUMBER.test(parts[1])
        && MAP_POSITION_NUMBER.test(parts[2])
        && MAP_POSITION_RATIO.test(parts[3]);

      if (!valid && String(raw || '').trim()) {
        warn('ignoring malformed live_preview_map_position, using CSS defaults:', raw);
      }

      containers.forEach(function (el) {
        if (!valid) {
          MAP_POSITION_VARS.forEach(function (name) { el.style.removeProperty(name); });
          return;
        }
        el.style.setProperty('--clp-top', parts[0] + '%');
        el.style.setProperty('--clp-left', parts[1] + '%');
        el.style.setProperty('--clp-width', parts[2] + '%');
        el.style.setProperty('--clp-ratio', parts[3]);
        // Unitless copies for the slide's translate() math, which can't divide a percentage by a percentage.
        el.style.setProperty('--clp-left-n', parts[1]);
        el.style.setProperty('--clp-width-n', parts[2]);
      });
      log('applyMapPosition()', raw, valid ? parts : '(defaults)');
    }

    applyMapPosition(containers[0].dataset.cruiseLivePreviewMapPosition);

    // Captured while the containers are still in their slides — they later move into the zoom modal.
    const frameScopeEls = containers.map(function (el) { return el.closest('.product'); })
      .filter(function (el, i, all) { return el && all.indexOf(el) === i; });

    // Only ever turned back on for a base image the server actually rendered, never conjured up.
    function setFramed(framed) {
      containers.forEach(function (el) { el.classList.toggle('cruise-live-preview-overlay--framed', framed); });
      frameScopeEls.forEach(function (el) { el.classList.toggle('product-has-live-preview-frame', framed); });
      log('setFramed()', framed);
    }

    // Shared by both variant paths: this product's own picker, and the album's Theme/Cover/Format radios.
    // Covers every gallery instance, not just the mounted one, or the other keeps a stale image after a remount.
    function applyBaseImage(entry) {
      const baseImgs = Array.prototype.slice.call(document.querySelectorAll('[data-cruise-live-preview-base-image]'));
      const url = entry && entry.url;
      baseImgs.forEach(function (baseImg) {
        if (!url) {
          baseImg.style.display = 'none';
          return;
        }
        // srcset would otherwise outrank this new src — same reasoning as applyBaseImageZoomResolution().
        baseImg.removeAttribute('srcset');
        baseImg.src = url;
        baseImg.dataset.cruiseLivePreviewBaseImageZoomSrc = entry.zoom || '';
        preloadBaseImageZoom(baseImg);
        baseImg.style.display = '';
      });
      applyMapPosition(entry && entry.pos);
      setFramed(!!(baseImgs.length && url));
    }

    const ownBaseImages = window.CruiseLivePreviewBaseImages || {};
    const hasOwnBaseImages = Object.keys(ownBaseImages).length > 0;

    const config = window.CruiseLivePreviewConfig || {};
    const variants = window.CruiseLivePreviewVariants || [];
    const initialVariant = window.CruiseLivePreviewInitialVariant || null;
    const frameKeys = window.CruiseLivePreviewFrameKeys || {};

    // The API parses this string into print size + orientation, so a variant whose own title doesn't parse
    // can supply a canonical one via its live_preview_frame_key metafield.
    function frameKeyFor(variant) {
      if (!variant) return '';
      return frameKeys[variant.id] || variant.title || '';
    }
    // Album mode only — see architecture.md §4e.
    const needsComposite = !!window.CruiseLivePreviewNeedsComposite;

    log('config:', config);
    log('variants:', variants);
    log('initialVariant:', initialVariant);

    const noPrevImgEl = document.getElementById('cruise-view-map___no_prev_img');
    const foundTextFailEl = document.getElementById('found-text-fail');
    const styleDataEl = document.getElementById('styleData');
    const titleInput = document.getElementById('title');

    const pillEl = document.querySelector('[data-cruise-live-preview-pill]');
    const pillLoadingEl = pillEl && pillEl.querySelector('[data-cruise-live-preview-pill-loading]');
    const pillReadyEl = pillEl && pillEl.querySelector('[data-cruise-live-preview-pill-ready]');
    const PILL_HEADER_GAP = 16;

    const desktopQuery = window.matchMedia('(min-width: 750px)');

    // Grey out Size/Frame/Orientation combos the widget can't render/print.
    const variantPickerEl = document.querySelector('variant-radios, variant-selects');

    // The widget has no setStyle() — style is fixed at mount, so a change means remounting.
    function currentStyle() {
      return styleDataEl && styleDataEl.value ? styleDataEl.value : 'standard';
    }

    let preview = null;
    let mountedStyle = null;
    let activeContainer = null;
    let activeSlider = null;
    let activeThumbnailImg = null;
    let homeSlideLi = null;
    let pillGalleryEl = null;
    let pillObserver = null;
    let pillCarouselMostlyHidden = false;
    let lastFrameKey = initialVariant;
    let lastVoyageIdentity = null;
    let lastQueuedIdentityKey = null;
    let runDebounceTimer = null;
    let latestUnresolvedVariants = null;

    // Bumped on every performRun()/cruiseLivePreviewReset() — lets a stale in-flight run discard its own result.
    let runGeneration = 0;

    // True from renderstart until the run settles — read by the photobook button lock.
    window.CruiseLivePreviewRenderPending = false;
    function setRenderPending(pending) {
      window.CruiseLivePreviewRenderPending = pending;
      document.dispatchEvent(new CustomEvent('cruise-live-preview:pending-changed', { detail: pending }));
    }

    // The full framed map (border/title/ship-name/dates baked in), not just the bare inset — see architecture.md §4e.
    window.CruiseLivePreviewCompositeImageUrl = null;

    const COMPOSITE_POLL_MS = 1500;
    const COMPOSITE_POLL_MAX_ATTEMPTS = 20; // ~30s, matches the same order of magnitude as RUN_TIMEOUT_MS's safety margin

    // POST only returns { exists, jobId, cached } — no imageUrl despite the docs' example — must be polled separately
    // at GET /voyage/preview/composite/{jobId} (a different path than the regular /voyage/preview/{jobId} poll,
    // confirmed live). See architecture.md §4e.
    function pollCompositeImage(jobId, attempt) {
      fetch(config.apiBaseUrl + '/voyage/preview/composite/' + encodeURIComponent(jobId), {
        headers: { 'x-api-key': config.apiKey, 'x-client-id': config.apiClientId }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.status === 'ready' && data.imageUrl) {
            window.CruiseLivePreviewCompositeImageUrl = data.imageUrl;
            log('fetchCompositeImage(): ready', data.imageUrl);
            return;
          }
          if (data && data.status === 'failed') {
            warn('fetchCompositeImage(): composite render failed', data);
            return;
          }
          if (attempt >= COMPOSITE_POLL_MAX_ATTEMPTS) {
            warn('fetchCompositeImage(): gave up polling after', attempt, 'attempts', data);
            return;
          }
          setTimeout(function () { pollCompositeImage(jobId, attempt + 1); }, COMPOSITE_POLL_MS);
        })
        .catch(function (err) {
          warn('fetchCompositeImage(): poll failed, falling back to the plain inset', err);
        });
    }

    // Fire-and-forget, best-effort — never blocks or throws past its own catch. Started on 'revealed' so it has a
    // head start over the customer noticing the render and clicking "Build my photobook" (composite render takes a
    // few seconds server-side, plus the poll above).
    function fetchCompositeImage(voyageIdentity) {
      if (!needsComposite || !lastFrameKey) return;
      const styleValue = styleDataEl && styleDataEl.value ? styleDataEl.value : 'standard';
      const authHeaders = { 'x-api-key': config.apiKey, 'x-client-id': config.apiClientId };

      fetch(
        config.apiBaseUrl + '/prints/frames?style=' + encodeURIComponent(styleValue) + '&variant=' + encodeURIComponent(lastFrameKey),
        { headers: authHeaders }
      )
        .then(function (res) { return res.json(); })
        .then(function (data) {
          const frame = data && data.frames && data.frames[lastFrameKey];
          if (!frame) {
            warn('fetchCompositeImage(): variant unresolved in /prints/frames, skipping', lastFrameKey);
            return null;
          }
          return fetch(config.apiBaseUrl + '/voyage/preview/composite', {
            method: 'POST',
            headers: Object.assign({ 'Content-Type': 'application/json' }, authHeaders),
            body: JSON.stringify(Object.assign({}, voyageIdentity, {
              style: styleValue,
              height: frame.height,
              width: frame.width,
              layout: frame.orientation,
              // fields.title is required by the endpoint even though we have nothing to send — #photobookTitle is
              // hidden on this template, see architecture.md §4e.
              fields: { title: '' }
            }))
          }).then(function (res) { return res.json(); });
        })
        .then(function (data) {
          if (!data) return;
          if (data.exists === false || !data.jobId) {
            warn('fetchCompositeImage(): no composite job for this voyage', data);
            return;
          }
          pollCompositeImage(data.jobId, 1);
        })
        .catch(function (err) {
          warn('fetchCompositeImage() failed, falling back to the plain inset', err);
        });
    }

    function pickContainer() {
      for (let i = 0; i < containers.length; i++) {
        if (containers[i].offsetParent !== null) return containers[i];
      }
      return containers[0];
    }

    // Looked up fresh, not cached — activeContainer moves between slides/the modal, so its sibling base
    // image does too. Null outside framed mode; every call site already guards on that.
    function getBaseImageEl() {
      if (!activeContainer || !activeContainer.parentElement) return null;
      return activeContainer.parentElement.querySelector('.cruise-live-preview-base-image');
    }

    // Disclaimer trigger/tooltip stay in the gallery <li>, never move into the modal like the base image does.
    function getDisclaimerHomeLi() {
      return homeSlideLi || (activeContainer && activeContainer.parentElement);
    }

    // No-op when the data attributes weren't rendered (disclaimer off/disabled).
    function setDisclaimerHidden(hidden) {
      const li = getDisclaimerHomeLi();
      if (!li) return;
      const trigger = li.querySelector('[data-cruise-live-preview-disclaimer-trigger]');
      const tooltip = li.querySelector('[data-cruise-live-preview-disclaimer]');
      if (trigger) trigger.hidden = hidden;
      if (tooltip) {
        tooltip.hidden = hidden;
        // Don't leave an open tooltip stuck open-but-hidden.
        if (hidden) tooltip.classList.remove('show', 'initial-show');
      }
    }

    // Thumbnails live in a sibling <slider-component>, matched via the shared data-media-id/data-target value.
    function syncThumbnailReference() {
      activeThumbnailImg = null;
      if (!activeContainer) return;
      const li = activeContainer.parentElement;
      const gallery = activeContainer.closest('media-gallery');
      if (!li || !gallery) return;
      const mediaKey = li.getAttribute('data-media-id');
      if (!mediaKey) return;
      activeThumbnailImg = gallery.querySelector('[data-target="' + mediaKey + '"] img');
      log('syncThumbnailReference()', mediaKey, activeThumbnailImg);
    }

    function rememberOriginalThumbnail(img) {
      if (!img || img.dataset.cruiseLivePreviewOriginalSrc !== undefined) return;
      img.dataset.cruiseLivePreviewOriginalSrc = img.getAttribute('src') || '';
      img.dataset.cruiseLivePreviewOriginalSrcset = img.getAttribute('srcset') || '';
    }

    // Plain undimmed photo — used for both idle and fallback states.
    function restoreThumbnail() {
      const img = activeThumbnailImg;
      if (!img) return;
      rememberOriginalThumbnail(img);
      if (img.dataset.cruiseLivePreviewOriginalSrcset) {
        img.setAttribute('srcset', img.dataset.cruiseLivePreviewOriginalSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('src', img.dataset.cruiseLivePreviewOriginalSrc || img.src);
      img.classList.remove('cruise-live-preview-thumbnail-dim');
    }

    // Dim only once a render is actually in flight (see 'renderstart').
    function dimThumbnail() {
      restoreThumbnail();
      if (activeThumbnailImg) activeThumbnailImg.classList.add('cruise-live-preview-thumbnail-dim');
    }

    // Successful render — mirror the same rendered map into the thumbnail.
    function revealThumbnail(imageUrl) {
      const img = activeThumbnailImg;
      if (!img || !imageUrl) return;
      rememberOriginalThumbnail(img);
      img.removeAttribute('srcset');
      img.setAttribute('src', imageUrl);
      img.classList.remove('cruise-live-preview-thumbnail-dim');
    }

    // Re-applies the current render outcome to whatever activeThumbnailImg now points to, since a photobook
    // variant switch (unlike a Dawn variant change) never triggers a fresh performRun() to do it itself.
    function applyCurrentRenderStateToThumbnail() {
      if (window.CruiseLivePreviewRenderPending) {
        dimThumbnail();
      } else if (window.CruiseLivePreviewLastImageUrl) {
        revealThumbnail(window.CruiseLivePreviewLastImageUrl);
      } else {
        restoreThumbnail();
      }
    }

    // Mobile carousel pill — reuses the same two render-state globals as applyCurrentRenderStateToThumbnail().
    function updatePillVisibility() {
      if (!pillEl) return;
      const state = window.CruiseLivePreviewRenderPending ? 'loading' : (window.CruiseLivePreviewLastImageUrl ? 'ready' : null);
      // Refreshed here too, not just on scroll/resize — otherwise a pill turning visible long after load stays stale.
      updatePillPosition();
      pillEl.hidden = !state || !pillCarouselMostlyHidden;
      if (pillLoadingEl) pillLoadingEl.hidden = state !== 'loading';
      if (pillReadyEl) pillReadyEl.hidden = state !== 'ready';
    }

    // Re-targeted on every mountInto() — the visible gallery instance changes on remount (desktop/mobile swap).
    function observePillCarousel() {
      if (!pillEl || !activeContainer) return;
      const galleryEl = activeContainer.closest('media-gallery');
      if (!galleryEl || galleryEl === pillGalleryEl) return;
      if (pillObserver) pillObserver.disconnect();
      pillGalleryEl = galleryEl;
      pillObserver = new IntersectionObserver(function (entries) {
        pillCarouselMostlyHidden = entries[0].intersectionRatio < 0.5;
        updatePillVisibility();
      }, { threshold: [0, 0.5, 1] });
      pillObserver.observe(galleryEl);
    }

    // Live header rect, not --header-height — that only updates on load/breakpoint change, not hide/reveal.
    function updatePillPosition() {
      if (!pillEl) return;
      const header = document.querySelector('.section-header');
      if (!header) return;
      pillEl.style.top = Math.max(header.getBoundingClientRect().bottom, 0) + PILL_HEADER_GAP + 'px';
    }

    if (pillReadyEl) {
      pillReadyEl.addEventListener('click', function () {
        if (!pillGalleryEl) return;
        // is-active tracks the last setActiveMedia() call, not scroll position, so always call it here.
        const widgetSlide = activeContainer && activeContainer.closest('[data-media-id]');
        if (widgetSlide && typeof pillGalleryEl.setActiveMedia === 'function') {
          pillGalleryEl.setActiveMedia(widgetSlide.dataset.mediaId, false);
        }
        const header = document.querySelector('.section-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const targetTop = window.pageYOffset + pillGalleryEl.getBoundingClientRect().top - headerHeight - PILL_HEADER_GAP;
        window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      });
    }

    if (pillEl) {
      window.addEventListener('scroll', updatePillPosition, { passive: true });
      window.addEventListener('resize', updatePillPosition);
      updatePillPosition();
      updatePillVisibility();
    }

    // Wraps the bare modal <img> on demand instead of editing the shared snippet.
    function ensureModalWrapper(img) {
      const existing = img.parentElement;
      if (existing && existing.classList.contains('cruise-live-preview-modal-wrap')) {
        return existing;
      }
      const wrap = document.createElement('div');
      wrap.className = 'cruise-live-preview-modal-wrap';
      wrap.style.position = 'relative';
      // Mirror .active onto the wrap — CSS hides non-.active direct children on mobile.
      if (img.classList.contains('active')) wrap.classList.add('active');
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
      return wrap;
    }

    // Read fresh from the slide's own modal-opener button.
    function getCurrentMediaId() {
      const li = activeContainer && activeContainer.parentElement;
      const toggleBtn = li && li.querySelector('.product__media-toggle');
      return toggleBtn && toggleBtn.getAttribute('data-media-id');
    }

    let hiddenModalImg = null;
    let wrappedModalImg = null;
    let zoomedBaseImg = null;
    let zoomedBaseImgOriginalSrcset = null;

    // Warms the browser cache well before the modal actually opens, so the src swap below resolves instantly
    // instead of visibly loading a fresh, larger image the moment the customer zooms.
    function preloadBaseImageZoom(baseImg) {
      if (!baseImg || !desktopQuery.matches) return;
      const zoomSrc = baseImg.dataset.cruiseLivePreviewBaseImageZoomSrc;
      if (zoomSrc) new Image().src = zoomSrc;
    }

    // srcset would otherwise outrank the swapped-in zoom src, so it's dropped and restored on close.
    function applyBaseImageZoomResolution(baseImg) {
      if (!baseImg || !desktopQuery.matches) return;
      const zoomSrc = baseImg.dataset.cruiseLivePreviewBaseImageZoomSrc;
      if (!zoomSrc) return;
      zoomedBaseImg = baseImg;
      zoomedBaseImgOriginalSrcset = baseImg.getAttribute('srcset');
      baseImg.removeAttribute('srcset');
      baseImg.src = zoomSrc;
    }

    function restoreBaseImageGalleryResolution() {
      if (!zoomedBaseImg) return;
      if (zoomedBaseImgOriginalSrcset !== null) zoomedBaseImg.setAttribute('srcset', zoomedBaseImgOriginalSrcset);
      zoomedBaseImg = null;
      zoomedBaseImgOriginalSrcset = null;
    }

    // Undoes ensureModalWrapper() on close, or the next variant switch's prepend() orphans the wrap.
    function unwrapModalImg() {
      if (!wrappedModalImg) return;
      const wrap = wrappedModalImg.parentElement;
      if (wrap && wrap.classList.contains('cruise-live-preview-modal-wrap')) {
        wrap.replaceWith(wrappedModalImg);
      }
      wrappedModalImg = null;
    }

    function moveOverlayBackToSlide() {
      restoreBaseImageGalleryResolution();
      if (hiddenModalImg) {
        hiddenModalImg.style.display = '';
        hiddenModalImg = null;
      }
      unwrapModalImg();
      if (!homeSlideLi || !activeContainer) return;
      if (activeContainer.parentElement === homeSlideLi) {
        homeSlideLi = null;
        return;
      }
      log('moving overlay back out of the modal');
      // Captured before the move below changes activeContainer.parentElement.
      const baseImg = getBaseImageEl();
      if (baseImg) homeSlideLi.appendChild(baseImg);
      homeSlideLi.appendChild(activeContainer);
      homeSlideLi = null;
    }

    // Always move to our slot on open — desktop shows all slides stacked, so no scroll-position tracking is needed.
    function onModalOpenAttributeChanged(mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.attributeName !== 'open') return;
        const modal = mutation.target;
        if (!modal.hasAttribute('open')) return; // only react to opening, not closing

        // Nothing rendered yet (idle — no cruise data entered, or a fallback state) — activeContainer itself is
        // invisible (no 'is-visible'), so transferring it would hide the real photo behind an empty box. Leave the
        // modal's own <img> alone and let it zoom normally.
        if (!activeContainer || !activeContainer.classList.contains('is-visible')) return;

        const mediaId = getCurrentMediaId();
        if (!mediaId) return;
        const modalImg = modal.querySelector('img[data-media-id="' + mediaId + '"]');
        if (!modalImg) {
          warn('onModalOpenAttributeChanged(): no matching modal image for media', mediaId);
          return;
        }

        log('moving overlay into modal for media', mediaId);
        // Captured before homeSlideLi is reassigned/anything moves — same element, just naming it for clarity below.
        const baseImg = getBaseImageEl();
        homeSlideLi = activeContainer.parentElement;
        const wrap = ensureModalWrapper(modalImg);
        wrappedModalImg = modalImg;
        // Photobook mode keeps the real photo visible instead of hiding it.
        const isPhotobookPosition = activeContainer.classList.contains('cruise-live-preview-overlay--framed');
        wrap.classList.toggle('cruise-live-preview-modal-wrap--framed', isPhotobookPosition);
        if (isPhotobookPosition) {
          hiddenModalImg = null;
        } else {
          hiddenModalImg = modalImg;
          // display:none, not visibility — avoids inheriting the modal image's unconstrained mobile size.
          modalImg.style.display = 'none';
        }
        // Appended before activeContainer so it stacks behind it (matches the slide's own DOM order).
        if (baseImg) wrap.appendChild(baseImg);
        applyBaseImageZoomResolution(baseImg);
        wrap.appendChild(activeContainer);
      });
    }

    function setupModalObserver() {
      const li = activeContainer && activeContainer.parentElement;
      const modalOpener = li && li.querySelector('modal-opener[data-modal]');
      const modal = modalOpener && document.querySelector(modalOpener.getAttribute('data-modal'));
      if (!modal) {
        warn('setupModalObserver(): could not find the product modal element');
        return;
      }
      new MutationObserver(onModalOpenAttributeChanged).observe(modal, {
        attributes: true,
        attributeFilter: ['open']
      });
      log('watching product-modal for the open attribute', modal);
    }

    // A newly switched-in base image that hasn't loaded yet would leave the widget drawn over the slide's own photo.
    const BASE_IMAGE_WAIT_MS = 4000;
    let baseImageWaitCleanup = null;

    function cancelBaseImageWait() {
      if (baseImageWaitCleanup) baseImageWaitCleanup();
    }

    // Keeps widget + base image hidden until the active base image loads; onFail on error or BASE_IMAGE_WAIT_MS.
    function holdForBaseImage(onReady, onFail) {
      cancelBaseImageWait();
      const baseImg = getBaseImageEl();
      if (!baseImg || baseImg.style.display === 'none' || !baseImg.getAttribute('src')
        || (baseImg.complete && baseImg.naturalWidth > 0)) {
        onReady();
        return;
      }
      if (baseImg.complete) {
        onFail();
        return;
      }

      log('holdForBaseImage(): waiting for', baseImg.src);
      if (activeContainer) activeContainer.classList.remove('is-visible');
      baseImg.classList.remove('is-visible');
      if (noPrevImgEl) noPrevImgEl.style.display = 'none';
      if (foundTextFailEl) foundTextFailEl.style.display = 'none';
      setDisclaimerHidden(false);

      function settle(loaded) {
        cancelBaseImageWait();
        log('holdForBaseImage(): settled, loaded =', loaded);
        (loaded ? onReady : onFail)();
      }
      const onLoad = function () { settle(true); };
      const onError = function () { settle(false); };
      const timer = setTimeout(onError, BASE_IMAGE_WAIT_MS);
      baseImg.addEventListener('load', onLoad);
      baseImg.addEventListener('error', onError);
      baseImageWaitCleanup = function () {
        clearTimeout(timer);
        baseImg.removeEventListener('load', onLoad);
        baseImg.removeEventListener('error', onError);
        baseImageWaitCleanup = null;
      };
    }

    // Stays on the fallback until the next variant or cruise-details change retries.
    function failBaseImageWait() {
      warn('base image failed or did not load within ' + BASE_IMAGE_WAIT_MS + 'ms, falling back');
      runGeneration++;
      setRenderPending(false);
      window.CruiseLivePreviewLastImageUrl = null;
      showFallback('terminal');
      updatePillVisibility();
    }

    function showOverlay() {
      if (baseImageWaitCleanup) {
        log('showOverlay() deferred until the base image loads');
        return;
      }
      log('showOverlay()', activeContainer);
      if (activeContainer) activeContainer.classList.add('is-visible');
      const baseImg = getBaseImageEl();
      if (baseImg) baseImg.classList.add('is-visible');
      if (noPrevImgEl) noPrevImgEl.style.display = 'none';
      if (foundTextFailEl) foundTextFailEl.style.display = 'none';
      setDisclaimerHidden(true);

      if (activeContainer) {
        const rect = activeContainer.getBoundingClientRect();
        const computed = window.getComputedStyle(activeContainer);
        log('container box:', {
          width: rect.width,
          height: rect.height,
          top: rect.top,
          left: rect.left,
          opacity: computed.opacity,
          display: computed.display,
          visibility: computed.visibility,
          zIndex: computed.zIndex,
          childElementCount: activeContainer.childElementCount,
          innerHTMLLength: activeContainer.innerHTML.length
        });
      }
    }

    // Every non-'revealed' outcome shows the same generic fallback copy.
    function showFallback(outcome) {
      log('showFallback()', activeContainer, outcome);
      if (activeContainer) activeContainer.classList.remove('is-visible');
      const baseImg = getBaseImageEl();
      if (baseImg) baseImg.classList.remove('is-visible');
      if (noPrevImgEl) noPrevImgEl.style.display = 'block';
      if (foundTextFailEl) foundTextFailEl.style.display = 'block';
      setDisclaimerHidden(false);
      restoreThumbnail();
    }

    // Idle state — real photo shows, no widget shell or fallback message.
    function hideAll() {
      log('hideAll()', activeContainer);
      if (activeContainer) activeContainer.classList.remove('is-visible');
      const baseImg = getBaseImageEl();
      if (baseImg) baseImg.classList.remove('is-visible');
      if (noPrevImgEl) noPrevImgEl.style.display = 'none';
      if (foundTextFailEl) foundTextFailEl.style.display = 'none';
      setDisclaimerHidden(false);
      restoreThumbnail();
    }

    function handleRunOutcome(result) {
      log('run() settled with', result);
      setRenderPending(false);
      if (result && result.outcome === 'revealed') {
        showOverlay();
        revealThumbnail(result.imageUrl);
        // Read by cruise-photobook-builder-mount.js as the real cover image, instead of its own placeholder.
        window.CruiseLivePreviewLastImageUrl = result.imageUrl;
      } else {
        warn('outcome is not "revealed", falling back:', result);
        window.CruiseLivePreviewLastImageUrl = null;
        showFallback(result && result.outcome);
      }
      updatePillVisibility();
    }

    // Safety net for a run() that never settles — see architecture.md §4d.
    const RUN_TIMEOUT_MS = 40000;

    function performRun(voyageIdentity) {
      if (!preview) {
        warn('performRun() called with no mounted preview instance');
        return;
      }

      // Captured now — if runGeneration has moved on by the time this settles (a newer performRun(), or a
      // cruiseLivePreviewReset() while this one was still in flight), the result below is stale and gets discarded.
      const myGeneration = ++runGeneration;

      holdForBaseImage(function () {
        startRun(voyageIdentity, myGeneration);
      }, failBaseImageWait);
    }

    function startRun(voyageIdentity, myGeneration) {
      log('run() starting with', voyageIdentity);

      // Re-applied here, not only on variant change — a run deferred by holdForBaseImage() must still use the latest frame.
      if (lastFrameKey) preview.setFrame(lastFrameKey);

      // Started in parallel with run(), not after it settles — none of composite's inputs depend on the animated
      // render's own output, see architecture.md §4e. Superseding request, so any older composite is stale now.
      window.CruiseLivePreviewCompositeImageUrl = null;
      fetchCompositeImage(voyageIdentity);

      let settled = false;
      const runTimeoutTimer = setTimeout(function () {
        if (settled || myGeneration !== runGeneration) return;
        settled = true;
        error('run() did not settle within ' + RUN_TIMEOUT_MS + 'ms, forcing fallback so the customer isn\'t stuck');
        setRenderPending(false);
        window.CruiseLivePreviewLastImageUrl = null;
        showFallback('terminal');
        updatePillVisibility();
      }, RUN_TIMEOUT_MS);

      preview.run(voyageIdentity).then(function (result) {
        if (settled || myGeneration !== runGeneration) {
          log('run() settled after being superseded/reset, discarding stale result', result);
          return;
        }
        settled = true;
        clearTimeout(runTimeoutTimer);
        handleRunOutcome(result);
      }).catch(function (err) {
        if (settled || myGeneration !== runGeneration) return;
        settled = true;
        clearTimeout(runTimeoutTimer);
        error('run() rejected', err);
        setRenderPending(false);
        window.CruiseLivePreviewLastImageUrl = null;
        showFallback();
        updatePillVisibility();
      });
    }

    function mountInto(container) {
      activeContainer = container;
      // Scope for finding the active slide's <li> on variant change (see the subscriber below).
      activeSlider = container.closest('slider-component');
      syncThumbnailReference();
      observePillCarousel();
      preloadBaseImageZoom(getBaseImageEl());

      const options = {
        apiBaseUrl: config.apiBaseUrl,
        headers: {
          'x-api-key': config.apiKey,
          'x-client-id': config.apiClientId
        },
        style: currentStyle(),
        variants: variants
      };
      mountedStyle = options.style;
      log('mounting createVoyagePreview() into', container, 'with options', options);

      preview = window.PreviewEmbed.createVoyagePreview(container, options);

      preview.on('ready', function (payload) {
        log('event: ready', payload);
        latestUnresolvedVariants = new Set((payload && payload.unresolved) || []);
        applyUnresolvedGreyOut();
      });
      preview.on('renderstart', function () {
        log('event: renderstart');
        // Reveal only once a render actually starts, not on mount.
        showOverlay();
        dimThumbnail();
        setRenderPending(true);
        updatePillVisibility();
      });
      preview.on('rendercomplete', function (result) {
        log('event: rendercomplete', result);
      });
      preview.on('rendererror', function (result) {
        warn('event: rendererror', result);
      });
      preview.on('framefailed', function (payload) {
        warn('event: framefailed', payload);
      });

      // Stays hidden until a run() actually starts.
      hideAll();

      if (lastFrameKey) {
        log('setFrame() on mount with', lastFrameKey);
        preview.setFrame(lastFrameKey);
      }
      if (lastVoyageIdentity) performRun(lastVoyageIdentity);
    }

    function remount() {
      const next = pickContainer();
      if (next === activeContainer) return;
      remountInto(next);
    }

    function remountInto(next) {
      log('remount: switching container', activeContainer, '->', next);
      if (activeContainer) activeContainer.classList.remove('is-visible');
      // The old container's own base image (a separate DOM element from the new container's — main vs
      // duplicate gallery instance, not the same node) — captured before activeContainer is reassigned below.
      const oldBaseImg = getBaseImageEl();
      if (oldBaseImg) oldBaseImg.classList.remove('is-visible');
      if (preview) {
        try { preview.destroy(); } catch (e) { warn('destroy() threw', e); }
        preview = null;
      }
      mountInto(next);
    }

    // Independent read of the same JSON Dawn's own getVariantData() parses (global.js:1196).
    function getPickerVariantData() {
      if (!variantPickerEl) return [];
      const scriptEl = variantPickerEl.querySelector('[type="application/json"]');
      if (!scriptEl) return [];
      try {
        return JSON.parse(scriptEl.textContent) || [];
      } catch (e) {
        warn('failed to parse variant picker JSON', e);
        return [];
      }
    }

    // Mirrors product-variant-options.liquid's option_disabled algorithm, plus: not in latestUnresolvedVariants.
    function applyUnresolvedGreyOut() {
      if (!variantPickerEl || !latestUnresolvedVariants) return;

      const variants = getPickerVariantData();
      if (!variants.length) return;

      const unresolvedLabel = window.CruiseLivePreviewUnresolvedLabel || '';
      const fieldsets = Array.prototype.slice.call(variantPickerEl.querySelectorAll('fieldset'));
      const isRadioPicker = fieldsets.length > 0;
      const groups = isRadioPicker ? fieldsets : Array.prototype.slice.call(variantPickerEl.querySelectorAll('select'));

      const selectedByPosition = [];

      groups.forEach(function (group, index) {
        const position = index + 1;
        const inputs = isRadioPicker
          ? Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'))
          : Array.prototype.slice.call(group.querySelectorAll('option'));

        inputs.forEach(function (input) {
          const value = input.value;
          const resolvable = variants.some(function (variant) {
            if (variant['option' + position] !== value) return false;
            for (let p = 1; p < position; p++) {
              if (variant['option' + p] !== selectedByPosition[p - 1]) return false;
            }
            return variant.available && !latestUnresolvedVariants.has(frameKeyFor(variant));
          });

          input.disabled = !resolvable;

          if (isRadioPicker) {
            if (!resolvable) {
              input.setAttribute('aria-label', value + ' - ' + unresolvedLabel);
            } else {
              input.removeAttribute('aria-label');
            }
          } else {
            const baseText = input.getAttribute('data-cruise-live-preview-base-text') || input.textContent;
            input.setAttribute('data-cruise-live-preview-base-text', baseText);
            input.textContent = resolvable ? baseText : baseText + ' (' + unresolvedLabel + ')';
          }
        });

        selectedByPosition[index] = isRadioPicker
          ? (group.querySelector('input:checked') ? group.querySelector('input:checked').value : null)
          : group.value;
      });
    }

    if (variantPickerEl) {
      // Fires after Dawn's own change listener (already attached by its constructor) — no setTimeout needed.
      variantPickerEl.addEventListener('change', applyUnresolvedGreyOut);
    }

    mountInto(pickContainer());
    setupModalObserver();

    // Fires for any modal close — moveOverlayBackToSlide() is a no-op unless we're actually inside one.
    document.body.addEventListener('modalClosed', moveOverlayBackToSlide);

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', remount);
    } else if (typeof desktopQuery.addListener === 'function') {
      // Safari < 14 fallback
      desktopQuery.addListener(remount);
    }

    // Lever A — size/orientation change, via Dawn's own variant-change pub/sub.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event && event.data && event.data.variant;
        log('variant-change event received', event);
        if (!variant || !variant.title) {
          warn('variant-change event had no variant.title, ignoring', event);
          return;
        }

        lastFrameKey = frameKeyFor(variant);
        if (!preview) return;

        // Skipped in album mode, where the cover comes from the album variant instead.
        if (hasOwnBaseImages) applyBaseImage(ownBaseImages[variant.id]);

        // Follow Dawn's own newly-prepended slide so the widget doesn't get left behind.
        const mediaId = variant.featured_media && variant.featured_media.id;
        if (mediaId && activeSlider && activeContainer) {
          const targetLi = activeSlider.querySelector('[data-media-id$="-' + mediaId + '"]');
          if (targetLi && targetLi !== activeContainer.parentElement) {
            log('moving overlay into slide for new variant media', mediaId, targetLi);
            // Captured before the moves below change activeContainer.parentElement — otherwise this
            // would still resolve fine, but only by accident (getBaseImageEl() re-derives from
            // activeContainer.parentElement, which is about to point somewhere else).
            const baseImg = getBaseImageEl();
            if (baseImg) targetLi.appendChild(baseImg);
            targetLi.appendChild(activeContainer);
            syncThumbnailReference();
            // Plain photo by default — 'renderstart' dims it once a render actually starts.
            restoreThumbnail();
          } else if (!targetLi) {
            warn('could not find slide for variant media', mediaId);
          }
        }

        if (lastVoyageIdentity) {
          // performRun() applies the new frame itself, only once the new base image has loaded.
          performRun(lastVoyageIdentity);
        } else {
          log('setFrame() from variant change with', lastFrameKey);
          preview.setFrame(lastFrameKey);
        }
      });
    } else {
      warn('subscribe()/PUB_SUB_EVENTS not available, variant changes will not update the preview');
    }

    // photobook_gallery_product's own variant, unrelated to the PUB_SUB_EVENTS subscriber above.
    document.addEventListener('cruise:photobook-variant-changed', function (event) {
      const variant = event && event.detail && event.detail.variant;
      const baseImg = getBaseImageEl();
      applyBaseImage(variant && {
        url: variant.baseImageUrl,
        zoom: variant.baseImageZoomUrl,
        pos: variant.mapPosition
      });

      // Same "follow the newly-prepended slide" move as Lever A above, keyed off the photobook variant.
      const featuredMediaId = variant && variant.featuredMediaId;
      if (featuredMediaId && activeSlider && activeContainer) {
        const targetLi = activeSlider.querySelector('[data-media-id$="-pbx-' + featuredMediaId + '"]');
        if (targetLi && targetLi !== activeContainer.parentElement) {
          log('moving overlay into photobook slide for variant media', featuredMediaId, targetLi);
          if (baseImg) targetLi.appendChild(baseImg);
          targetLi.appendChild(activeContainer);
          syncThumbnailReference();
          applyCurrentRenderStateToThumbnail();
        } else if (!targetLi) {
          warn('could not find photobook slide for variant media', featuredMediaId);
        }
      }

      // No run to defer here — just re-hide an already-shown widget until the new cover loads.
      if (activeContainer && activeContainer.classList.contains('is-visible')) {
        holdForBaseImage(function () {
          if (window.CruiseLivePreviewRenderPending || window.CruiseLivePreviewLastImageUrl) showOverlay();
        }, failBaseImageWait);
      }
    });

    // Lever B — cruise details ready, called from checkRoute(); deduplicated by content since checkRoute() can retrigger with identical data.
    window.cruiseLivePreviewRequestRun = function (voyageIdentity) {
      const identityKey = JSON.stringify(voyageIdentity);
      if (identityKey === lastQueuedIdentityKey) {
        log('cruiseLivePreviewRequestRun() ignored, identical to last request', voyageIdentity);
        return;
      }
      lastQueuedIdentityKey = identityKey;

      log('cruiseLivePreviewRequestRun() queued', voyageIdentity);
      lastVoyageIdentity = voyageIdentity;
      clearTimeout(runDebounceTimer);
      runDebounceTimer = setTimeout(function () {
        // Ship-name-driven Partner tags only resolve once the customer types one, i.e. after the mount.
        if (preview && activeContainer && currentStyle() !== mountedStyle) {
          log('style changed since mount', mountedStyle, '->', currentStyle());
          remountInto(activeContainer); // mountInto() re-runs lastVoyageIdentity itself, already this one
          return;
        }
        performRun(voyageIdentity);
      }, 450);
    };

    // Form became incomplete again — back to idle.
    window.cruiseLivePreviewReset = function () {
      log('cruiseLivePreviewReset()');
      clearTimeout(runDebounceTimer);
      cancelBaseImageWait();
      runGeneration++; // invalidates any performRun() still in flight — see its own comment above
      lastVoyageIdentity = null;
      lastQueuedIdentityKey = null;
      window.CruiseLivePreviewLastImageUrl = null;
      window.CruiseLivePreviewCompositeImageUrl = null;
      setRenderPending(false);
      if (preview) preview.clear();
      hideAll();
      updatePillVisibility();
    };

    // Title is the only frame field the store can set directly — client-side, no render.
    if (titleInput) {
      titleInput.addEventListener('input', function () {
        log('setFields() with', { title: titleInput.value });
        if (preview) preview.setFields({ title: titleInput.value });
      });
    }
  });
})();
